import script from "./QModalOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalOrder.vue?vue&type=script&setup=true&lang=js"

import "./QModalOrder.vue?vue&type=style&index=0&id=553d661f&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-553d661f"]])

export default __exports__